import React from 'react';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import { useSelector } from 'react-redux';
import {
    UsagePricingDataTableContainer,
    UsagePricingDataContainer,
    UsagePricingTableFont,
} from 'src/common/components/orderDetails/detailsDataTable/DetailsDataTable.styled';
import {
    setItemsDataHandler,
    bundleRowToggleFunction,
    bundleArrowFunction,
    hasWhiteSpace,
    isIpad,
    logErrorToConsole,
} from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import BundleLayout from 'src/common/components/orderDetails/bundleCards/BundleLayout';
import BundleTag from 'src/common/components/orderDetails/bundleTag/BundleTag';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import PricingContainer from 'src/common/components/orderDetails/bundleCards/PricingContainer';
import { useTranslation } from 'react-i18next';

const PriceOverrideDatatable = ({
    data,
    handleSetItemClick,
    rowExpand,
    tableName,
    updateRowExpandHandler,
    isBundleTable,
    keyValue,
    bundleSubGroup,
    isEquity,
    
}) => {
    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    ); 
    const orderType = orderBasicDetails?.currentOrderType; 
    const { t } = useTranslation();
    let colData =
        orderType === 'KE'
            ? [
                  {
                      field: 'cfn',
                      header: t(
                          'reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription'
                      ),
                      width: '25%',
                  },
                  {
                      field: 'serialNo',
                      header: t(
                          'reportUsage.itemList.lotSerialInputPlaceHolder.lotOrSerial'
                      ),
                      width: '14%',
                  },
                  {
                      field: 'quantity',
                      header: t('reportUsage.itemList.qty'),
                      width: '14%',
                  },
                  {
                      field: 'poNumber',
                      header: t(
                          'orders.orderDetails.orderSummary.shippingDetails.poNumber'
                      ),
                      width: '14%',
                  },
                  {
                      field: 'discount',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.discount'
                      ),
                      width: '11%',
                  },
                  {
                      field: 'unitPrice',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.unitPrice'
                      ),
                      width: '11%',
                  },
                  {
                      field: 'extPrice',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.extPrice'
                      ),
                      width: '11%',
                  },
              ]
            : [
                  {
                      field: 'cfn',
                      header: t(
                          'reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription'
                      ),
                      width: '25%',
                  },
                  {
                      field: 'serialNo',
                      header: t(
                          'reportUsage.itemList.lotSerialInputPlaceHolder.lotOrSerial'
                      ),
                      width: '14%',
                  },
                  {
                      field: 'quantity',
                      header: t('consignmentBilling.inventory.usedQty'),
                      width: '14%',
                  },
                  {
                      field: 'poNumber',
                      header: t(
                          'orders.orderDetails.orderSummary.shippingDetails.poNumber'
                      ),
                      width: '14%',
                  },
                  {
                      field: 'discount',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.discount'
                      ),
                      width: '11%',
                  },
                  {
                      field: 'unitPrice',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.unitPrice'
                      ),
                      width: '11%',
                  },
                  {
                      field: 'extPrice',
                      header: t(
                          'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.extPrice'
                      ),
                      width: '11%',
                  },
              ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    padding: '0px 0px 0px 10px',
                    width: '30%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '30%',
                    padding: isIpad()
                        ? isEquity
                            ? '6px 0px 0px 10px'
                            : '0px 0px 0px 10px'
                        : '0px 0px 0px 10px',
                };
                extraProps.body = (rowData) => {
                    const isBundle =
                        rowData?.isBundleHeader && rowData.isBundleHeader
                            ? rowData.isBundleHeader
                            : false;
                    const isBundleItems =
                        rowData?.bundleItems && rowData.bundleItems.length > 0
                            ? true
                            : false;
                    return (
                        <>
                            <BundleLayout
                                isExpand={
                                    isBundle && isBundleItems
                                        ? bundleArrowFunction(
                                              rowData.cfn,
                                              rowExpand
                                          )
                                        : false
                                }
                                bundleClickHandler={() => {
                                    try {
                                    rowToggleHandler(rowData, 'cfn', rowExpand);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                                }}
                                isBundle={isBundle && isBundleItems}
                            >
                                <UsagePricingDataContainer
                                    justifyContent="flex-start"
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    height="100%"
                                    padding={orderType === 'KE' ? '10px 0' : ''}
                                >
                                    <UsagePricingDataContainer
                                        alignItems={'center'}
                                        justifyContent={'flex-start'}
                                        width={'100%'}
                                    >
                                        <CfnLabel
                                            cfnFontColor={isBundle && '#140F4B'}
                                            setItemHandler={setItemHandler}
                                            setDetailsData={rowData}
                                            cfn={rowData?.cfn && rowData.cfn}
                                            isShowSetItemDetails={
                                                !isBundle ? true : false
                                            }
                                            cursor={'pointer'}
                                             isBundle = {true}
                                        />
                                        {isBundle || isBundleItems ? (
                                            <BundleTag
                                                bundleFontOpacity={'0.92'}
                                                value={
                                                    (typeof window !== 'undefined' &&
                                                        window.innerWidth > sizes.mobileDevice &&
                                                        window.innerWidth <= sizes.largportraitDevice) 
                                                        ? 'B'
                                                        : 'Bundle'
                                                }
                                            />
                                        ) : null}
                                    </UsagePricingDataContainer>

                                    <ItemDescriptionLabel
                                        textOverflow="ellipsis"
                                        overflow="hidden"
                                        lineClamp="2"
                                        orient="vertical"
                                        lineHeight="18px"
                                        color="#3C3C3C"
                                        fontSize="12px"
                                        display="-webkit-box"
                                        marginContainer={'5px 0 0 0'}
                                        descHeight={'38px'}
                                        description={
                                            rowData?.description &&
                                            rowData.description
                                        }
                                    />
                                </UsagePricingDataContainer>
                            </BundleLayout>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                    //    padding: '0 0 0 2%',
                    width: '15%',
                    height: '42px',
                    textAlign: 'left',
                };

                extraProps.bodyStyle = {
                    width: '15%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={
                                rowData?.serialNo && rowData.serialNo
                                    ? rowData.serialNo
                                    : 'NONE'
                            }
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'10px 0 0 14px'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity': 
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '13%',
                    height: '42px',
                    textAlign: 'center',
                };
                extraProps.bodyStyle = {
                    width: '13%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'10px 0'}
                            >
                                {rowData?.quantity && (
                                    <>
                                        <UsagePricingTableFont
                                            fontFamily={'AvenirNextWorld Demi'}
                                            color={'#202124'}
                                            fontSize={'13px'}
                                        >
                                            {/* {`${
                                                rowData?.isUsed &&
                                                rowData.isUsed
                                                    ? 'Used:'
                                                    : 'Other:'
                                            }`} */}
                                        </UsagePricingTableFont>
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            margin={'0px 0px 0px 5px'}
                                        >
                                            {rowData.uom === 'packaging-PK'
                                                ? `${rowData.quantity} X PK`
                                                : `${rowData.quantity} X ${
                                                      rowData.uom
                                                          ? rowData.uom
                                                          : t(
                                                                'orders.shipTrackLabels.eaLabel'
                                                            )
                                                  }`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '15%',
                    height: '42px',
                    textAlign: 'left',
                };
                extraProps.bodyStyle = {
                    width: '15%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                height="100%"
                                padding={'10px 0 10px 4px'}
                            >
                                <UsagePricingTableFont className="common-po-number-dt-mask"
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'flex-start'}
                                    wordBreak={
                                        rowData?.poNumber
                                            ? hasWhiteSpace(rowData.poNumber)
                                                ? 'break-word'
                                                : 'break-all'
                                            : 'break-all'
                                    }
                                >
                                    {rowData?.poNumber && rowData.poNumber}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'discount':
                extraProps.headerStyle = {
                    padding: '0 8px 0 0',
                    width: '12%',
                    height: '42px',
                    textAlign: 'end',
                };
                extraProps.bodyStyle = {
                    width: '12%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="end"
                                flexDirection="column"
                                height="100%"
                                padding={'10px 0 0 0'} 
                            >
                                {isEquity ? (
                                    <UsagePricingTableFont color={'#E5047E'}>
                                        {rowData?.discount &&
                                        parseFloat(rowData.discount) !== 0
                                            ? `${parseFloat(
                                                  rowData.discount
                                              ).toFixed(2)}%`
                                            : null}
                                    </UsagePricingTableFont>
                                ) : (
                                    <UsagePricingTableFont color={'#E5047E'}>
                                        {rowData?.discount &&
                                        parseFloat(rowData.discount) !== 0
                                            ? `${parseFloat(
                                                  rowData.discount
                                              ).toFixed(2)} %`
                                            : null}
                                    </UsagePricingTableFont>
                                )}

                                {rowData?.isDiscount !== undefined &&
                                    !rowData?.isDiscount && (
                                        <UsagePricingTableFont
                                            color={'#E5047E'}
                                        >
                                            {t('common.increases')}
                                        </UsagePricingTableFont>
                                    )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'unitPrice':
                extraProps.headerStyle = {
                    padding: '2px 10px 2px 0px',
                    width: '16%',
                    height: '42px',
                    textAlign: 'right',
                    letterSpacing: ' 0.3px',
                };
                extraProps.bodyStyle = {
                    width: '16%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                // alignItemsContainer="center"
                                paddingContainer={'10px 6px 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                textAlign={'right'}
                                price={rowData.unitPrice}
                                subPrice={rowData.discountUnitPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    padding: '2px 20px 2px 0px',
                    width: '15%',
                    height: '42px',
                    textAlign:  'end',
                    letterSpacing: ' 0.3px',
                };
                extraProps.bodyStyle = {
                    width: '15%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                // alignItemsContainer="center"
                                paddingContainer={'10px 12px 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                textAlign={'right'}
                                price={rowData.extPrice}
                                subPrice={rowData.discountExtPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    let subColData = [
        {
            field: 'cfn',
            width: '23%',
        },
        {
            field: 'serialNo',
            width: '10%',
        },
        {
            field: 'quantity',
            width: '10%',
        },

        {
            field: 'poNumber',
            width: '12%',
        },
        {
            field: 'discount',
            width: '10%',
        },
        {
            field: 'unitPrice',
            width: '10%',
        },
        {
            field: 'extPrice',
            width: '10%',
        },
    ];

    subColData = subColData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '30%',
                    padding: '0px 0px 0px 10px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                justifyContent="flex-start"
                                flexDirection="column"
                                alignItems="flex-start"
                                // height="100%"
                                padding="10px 0"
                            >
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData?.cfn ? rowData.cfn : null}
                                    isShowSetItemDetails={true}
                                    cursor={'pointer'}
                                />
                                <ItemDescriptionLabel
                                    textOverflow="ellipsis"
                                    overflow="hidden"
                                    lineClamp="2"
                                    orient="vertical"
                                    lineHeight="18px"
                                    color="#3C3C3C"
                                    fontSize="12px"
                                    display="-webkit-box"
                                    marginContainer={'5px 0 0 0'}
                                    descHeight={'38px'}
                                    description={
                                        rowData?.description &&
                                        rowData.description
                                    }
                                />
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'serialNo':
                extraProps.headerStyle = {
                    display: 'none',
                };

                extraProps.bodyStyle = {
                    width: '12%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <SerialNoLabel
                            serialNo={rowData?.serialNo && rowData.serialNo}
                            alignItemsContainer={'flex-start'}
                            justifyContentContiner={'flex-start'}
                            heightContainer={'100%'}
                            marginContainer={'0px'}
                            paddingContainer={'10px 0'}
                        />
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'quantity':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '16%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="center"
                                height="100%"
                                padding={'10px 0'}
                                style={{
                                    paddingRight:
                                        orderType === 'ZLB' ||
                                        orderType === 'ZOR'
                                            ? '30px'
                                            : '0px',
                                }}
                            >
                                {rowData?.quantity && (
                                    <>
                                        <UsagePricingTableFont
                                            fontFamily={'AvenirNextWorld Demi'}
                                            color={'#202124'}
                                            fontSize={'13px'}
                                        >
                                            {/* {`${
                                                rowData?.isUsed &&
                                                rowData.isUsed
                                                    ? 'Used:'
                                                    : 'Other:'
                                            }`} */}
                                        </UsagePricingTableFont>
                                        <UsagePricingTableFont
                                            lineHeight="23px"
                                            letterSpacing="-0.11px"
                                            margin={'0px 0px 0px 5px'}
                                        >
                                            {rowData.uom === 'packaging-PK'
                                                ? `${rowData.quantity} X PK`
                                                : `${rowData.quantity} X ${rowData.uom}`}
                                        </UsagePricingTableFont>
                                    </>
                                )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'poNumber':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '13%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                height="100%"
                                padding={'10px 0'}
                                style={{
                                    paddingRight:
                                        orderType === 'ZLB' ||
                                        orderType === 'ZOR'
                                            ? '43px'
                                            : '0px',
                                }}
                            >
                                <UsagePricingTableFont className="common-po-number-dt-mask"
                                    lineHeight="23px"
                                    letterSpacing="-0.11px"
                                    textAlign={'flex-start'}
                                >
                                    {rowData?.poNumber && rowData.poNumber}
                                </UsagePricingTableFont>
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'unitPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '11%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-end"
                                paddingContainer={'15px 0px 0 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData.unitPrice}
                                subPrice={rowData.discountUnitPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'extPrice':
                extraProps.headerStyle = {
                    display: 'none',
                };
                extraProps.bodyStyle = {
                    width: '11%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <PricingContainer
                                alignItemsContainer="flex-end"
                                paddingContainer={'10px 0'}
                                marginContainer={'0'}
                                heightContainer={'100%'}
                                price={rowData.extPrice}
                                subPrice={rowData.discountExtPrice}
                            />
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'discount':
                extraProps.headerStyle = {
                    // padding: '0 0 0 2%',
                    width: '10%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '12%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <UsagePricingDataContainer
                                alignItems="center"
                                flexDirection="column"
                                height="100%"
                                padding={'10px 0'}
                            >
                                <UsagePricingTableFont color={'#E5047E'}>
                                    {rowData?.discount &&
                                    parseFloat(rowData.discount) !== 0
                                        ? `${parseFloat(
                                              rowData.discount
                                          ).toFixed(2)}%`
                                        : null}
                                </UsagePricingTableFont>
                                {rowData?.isDiscount !== undefined &&
                                    !rowData?.isDiscount && (
                                        <UsagePricingTableFont
                                            color={'#E5047E'}
                                        >
                                            {t('common.increases')}
                                        </UsagePricingTableFont>
                                    )}
                            </UsagePricingDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    const rowToggleHandler = (e, key, expandRow) => {
        const updateExpandrow = bundleRowToggleFunction(e, key, expandRow);
        updateRowExpandHandler(updateExpandrow, tableName);
    };

    return (
        <>
            <UsagePricingDataTableContainer>
                <Datatable
                    id={'orderDetails-details-priceoverride-datatable'}
                    backgroundColorOdd={'#F5F5F599'}
                    backgroundColorEven={'#FFFFFF99'}
                    columns={colData}
                    data={data}
                    showSubTable={isBundleTable}
                    subColDatas={subColData}
                    keyValue={keyValue}
                    bundleSubGroup={bundleSubGroup}
                    expandRow={rowExpand}
                    rowToggleHandler={rowToggleHandler}
                    rows={data?.length > 0 ? data.length : 0}
                />
            </UsagePricingDataTableContainer>
        </>
    );
};

export default PriceOverrideDatatable;
